import { notAllowedWord, reservedValues } from '../formElements/reservedKeywords';
import * as Yup from 'yup';
import { defaultFields1, localStorageKey } from './constant';
import React from 'react';
export const validateName = (value) => {
  if (!value || value.length === 0) {
    return 'Name is Required';
  }
  if (value && value.length > 100) {
    return `Name can\'t be more than 100 characters`;
  }
  if (!/^[0-9A-Za-z\s]+$/.test(value)) {
    return 'Name should not contain special characters.';
  }
  const lowercaseValue = value ? value.toLowerCase() : '';
  if (reservedValues.includes(lowercaseValue)) {
    return `This is reserved word please use another`;
  }
  if (notAllowedWord.includes(lowercaseValue)) {
    return `This type of word not allowed.`;
  }
};
export const validateNamesForField = (value) => {
  if (!value || value.length === 0) {
    return 'Name is Required';
  }
  if (value && value.length > 100) {
    return `Name can\'t be more than 100 characters`;
  }
  if (!/^[0-9A-Za-z\s_]+$/.test(value)) {
    return 'Name should not contain special characters.';
  }

  let dummy = value;
  let exactValue = dummy.replace(/\s/g, '').toLowerCase();
  if (defaultFields1.includes(exactValue)) {
    return 'This is System defined Field';
  }
  const lowercaseValue = value ? value.toLowerCase() : '';
  if (reservedValues.includes(lowercaseValue)) {
    return `This is reserved word please use another`;
  }
  if (notAllowedWord.includes(lowercaseValue)) {
    return `This type of word not allowed.`;
  }
};

export const validateNameWithNoSpace = (value) => {
  if (!value || value.length === 0) {
    return 'Name is Required';
  }
  if (value && value.length > 100) {
    return `Name can\'t be more than 100 characters`;
  }
  if (!/^[a-zA-Z_$][a-zA-Z_$0-9]*$/.test(value)) {
    return 'Name should not contain special characters.';
  }
  const lowercaseValue = value ? value.toLowerCase() : '';
  if (reservedValues.includes(lowercaseValue)) {
    return `This is reserved word please use another`;
  }
  if (notAllowedWord.includes(lowercaseValue)) {
    return `This type of word not allowed.`;
  }
};
export const validateValue = (value) => {
  if (!value || value.length === 0) {
    return "Value can't be blank";
  }
};

export const validateConstantType = (value) => {
  if (!value || value === '') {
    return 'Choose One';
  }
};

export const validateKeyWithNoSpace = (value) => {
  if (!value || value.length === 0) {
    return 'Key is Required';
  }
  if (value && value.length > 100) {
    return `Key can\'t be more than 100 characters`;
  }
  if (!/^[a-zA-Z_$][a-zA-Z_$0-9]*$/.test(value)) {
    return 'Key should not contain special characters.';
  }
  const lowercaseValue = value ? value.toLowerCase() : '';
  if (reservedValues.includes(lowercaseValue)) {
    return `This is reserved word please use another`;
  }
  if (notAllowedWord.includes(lowercaseValue)) {
    return `This type of word not allowed.`;
  }
};

export const validationSchemaForDomains = Yup.object().shape({
  domainName: Yup.string()
    .matches(
      /^(?!:\/\/)(?:[a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,6}$/,
      'Must be a valid custom domain name',
    )
    .required('Domain name is required'),
  apiDomainName: Yup.string()
    .matches(
      /^(?!:\/\/)(?:[a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,6}$/,
      'Must be a valid custom api domain',
    )
    .required('API domain  is required'),
});
const ipv4Regex =
  /^(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])$/;
const ipv6Regex =
  /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.){3,3}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.){3,3}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9]))$/;

export const validateIPAddress = () => {
  return Yup.object().shape({
    ipAddress: Yup.string()
      .required('IP Address is required')
      .test(
        'is-valid-ip',
        'Invalid IP address format. Only valid IPv4 and IPv6 addresses are allowed.',
        (value) => {
          if (!value) {
            return false;
          }
          const ipAddresses = value.split(',').map((ip) => ip.trim());
          return ipAddresses.every((ip) => ipv4Regex.test(ip) || ipv6Regex.test(ip));
        },
      ),
  });
};
export const validateIp = (ip) => {
  return ipv4Regex.test(ip) || ipv6Regex.test(ip);
};

export const validateXmlContent = (value) => {
  if (!value || value.trim() === '') {
    return false;
  }
  const parser = new DOMParser();
  const parsedDoc = parser.parseFromString(value, 'application/xml');
  const parserError = parsedDoc.getElementsByTagName('parsererror');
  if (parserError.length > 0) {
    return 'Invalid XML format! Please add valid XML format content.';
  }
  return false;
};

export const getThemeData = (themeName) => {
  const themeData = [
    {
      themeName: 'Default',
      colors: {
        primary: '#0d6efd',
        danger: '#dc3545',
        success: '#198754',
        warning: '#ffc107',
        info: '#0dcaf0',
        light: '#f8f9fa',
        dark: '#212529',
        link: '#0d6efd',
      },
      hoverColors: {
        primary: '#0d6efd',
        danger: '#dc3545',
        success: '#198754',
        warning: '#ffc107',
        info: '#0dcaf0',
        light: '#f8f9fa',
        dark: '#212529',
        link: '#0a58ca',
      },
      body: {
        color: '#212529',
        backgroundColor: '#fff',
        anchor: '#0d6efd',
        anchorHover: '#0a58ca',
      },
      defaultFonts: ` system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
      headingColor: '#212529',
    },
    {
      themeName: 'cerulean',
      colors: {
        primary: '#2fa4e7',
        danger: '#c71c22',
        success: '#73a839',
        warning: '#dd5600',
        info: '#033c73',
        light: '#f8f9fa',
        dark: '#343a40',
        link: ' #82c8f1',
      },
      hoverColors: {
        primary: '#2fa4e7',
        danger: '#c71c22',
        success: '#73a839',
        warning: '#dd5600',
        info: '#033c73',
        light: '#f8f9fa',
        dark: '#343a40',
        link: '#2683b9',
      },
      body: {
        color: '#dee2e6',
        backgroundColor: '#212529',
        anchor: '#82c8f1',
        anchorHover: '#9bd3f4',
      },
      defaultFonts: `system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
      headingColor: '#2fa4e7',
    },
    {
      themeName: 'cosmo',
      colors: {
        primary: '#2780e3',
        danger: '#ff0039',
        success: '#3fb618',
        warning: '#ff7518',
        info: '#9954bb',
        light: '#f8f9fa',
        dark: '#373a3c',
        link: ' #2780e3',
      },
      hoverColors: {
        primary: '#2780e3',
        danger: '#ff0039',
        success: '#3fb618',
        warning: '#ff7518',
        info: '#9954bb',
        light: '#f8f9fa',
        dark: '#373a3c',
        link: '#1f66b6',
      },
      body: {
        color: '#373a3c',
        backgroundColor: '#fff',
        anchor: '#7db3ee',
        anchorHover: '#97c2f1',
      },
      defaultFonts: `"Source Sans Pro", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol"`,
      headingColor: '#212529',
    },
    {
      themeName: 'cyborg',
      colors: {
        primary: '#2a9fd6',
        danger: '#c00',
        success: '#77b300',
        warning: '#f80',
        info: '#93c',
        light: '#222',
        dark: '#adafae',
        link: ' #2a9fd6',
      },
      hoverColors: {
        primary: '#2a9fd6',
        danger: '#c00',
        success: '#77b300',
        warning: '#f80',
        info: '#93c',
        light: '#222',
        dark: '#adafae',
        link: '#227fab',
      },
      body: {
        color: '#adafae',
        backgroundColor: '#060606',
        anchor: '#2a9fd6',
        anchorHover: '#227fab',
      },
      defaultFonts: `Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Helvetica Neue", Arial, sans-serif`,
      headingColor: '#fff',
    },
    {
      themeName: 'darkly',
      colors: {
        primary: '#375a7f',
        danger: '#e74c3c',
        success: '#00bc8c',
        warning: '#f39c12',
        info: '#3498db',
        light: '#adb5bd',
        dark: '#303030',
        link: '#00bc8c',
      },
      hoverColors: {
        primary: '#375a7f',
        danger: '#e74c3c',
        success: '#00bc8c',
        warning: '#f39c12',
        info: '#3498db',
        light: '#adb5bd',
        dark: '#303030',
        link: '#009670',
      },
      body: {
        color: '#fff',
        backgroundColor: '#222',
        anchor: '#00bc8c',
        anchorHover: '#009670',
      },
      defaultFonts: `Lato, -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol"`,
      headingColor: '#fff',
    },
    {
      themeName: 'flatly',
      colors: {
        primary: '#2c3e50',
        danger: '#e74c3c',
        success: '#18bc9c',
        warning: '#f39c12',
        info: '#3498db',
        light: '#ecf0f1',
        dark: '#7b8a8b',
        link: ' #18bc9c',
      },
      hoverColors: {
        primary: '#2c3e50',
        danger: '#e74c3c',
        success: '#18bc9c',
        warning: '#f39c12',
        info: '#3498db',
        light: '#ecf0f1',
        dark: '#7b8a8b',
        link: '#13967d',
      },
      body: {
        color: '#212529',
        backgroundColor: '#fff',
        anchor: '#18bc9c',
        anchorHover: '#13967d',
      },
      defaultFonts: `Lato, -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol"`,
      headingColor: '#212529',
    },
    {
      themeName: 'journal',
      colors: {
        primary: '#eb6864',
        danger: '#f57a00',
        success: '#22b24c',
        warning: '#f5e625',
        info: '#369',
        light: '#f8f9fa',
        dark: '#222',
        link: ' #eb6864',
      },
      hoverColors: {
        primary: '#eb6864',
        danger: '#f57a00',
        success: '#22b24c',
        warning: '#f5e625',
        info: '#369',
        light: '#f8f9fa',
        dark: '#222',
        link: '#bc5350',
      },
      body: {
        color: '#222',
        backgroundColor: '#fff',
        anchor: '#eb6864',
        anchorHover: '#bc5350',
      },
      defaultFonts: `system-ui, -apple-system, "Segoe UI", Roboto,
    "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
      headingColor: '#222',
    },
    {
      themeName: 'litera',
      colors: {
        primary: '#4582ec',
        danger: '#d9534f',
        success: '#02b875',
        warning: '#f0ad4e',
        info: '#17a2b8',
        light: '#f8f9fa',
        dark: '#343a40',
        link: ' #4582ec',
      },
      hoverColors: {
        primary: '#4582ec',
        danger: '#d9534f',
        success: '#02b875',
        warning: '#f0ad4e',
        info: '#17a2b8',
        light: '#f8f9fa',
        dark: '#343a40',
        link: '#3768bd',
      },
      body: {
        color: '#343a40',
        backgroundColor: '#fff',
        anchor: '#4582ec',
        anchorHover: '#3768bd',
      },
      defaultFonts: `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
      headingColor: '#343a40',
    },
    {
      themeName: 'lumen',
      colors: {
        primary: '#158cba',
        danger: '#ff4136',
        success: '#28b62c',
        warning: '#ff851b',
        info: '#75caeb',
        light: '#f6f6f6',
        dark: '#555',
        link: ' #158cba',
      },
      hoverColors: {
        primary: '#158cba',
        danger: '#ff4136',
        success: '#28b62c',
        warning: '#ff851b',
        info: '#75caeb',
        light: '#f6f6f6',
        dark: '#555',
        link: '#117095',
      },
      body: {
        color: '#222',
        backgroundColor: '#fff',
        anchor: '#158cba',
        anchorHover: '#117095',
      },
      defaultFonts: `"Source Sans Pro", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol"`,
      headingColor: '#222',
    },
    {
      themeName: 'lux',
      colors: {
        primary: '#1a1a1a',
        danger: '#d9534f',
        success: '#4bbf73',
        warning: '#f0ad4e',
        info: '#1f9bcf',
        light: '#fff',
        dark: '#343a40',
        link: ' #1a1a1a',
      },
      hoverColors: {
        primary: '#1a1a1a',
        danger: '#d9534f',
        success: '#4bbf73',
        warning: '#f0ad4e',
        info: '#1f9bcf',
        light: '#fff',
        dark: '#343a40',
        link: '#151515',
      },
      body: {
        color: '#55595c',
        backgroundColor: '#fff',
        anchor: '#1a1a1a',
        anchorHover: '#151515',
      },
      defaultFonts: `"Nunito Sans", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol"`,
      headingColor: '#1a1a1a',
    },
    {
      themeName: 'materia',
      colors: {
        primary: '#2196f3',
        danger: '#e51c23',
        success: '#4caf50',
        warning: '#ff9800',
        info: '#9c27b0',
        light: '#f8f9fa',
        dark: '#222',
        link: ' #2196f3',
      },
      hoverColors: {
        primary: '#2196f3',
        danger: '#e51c23',
        success: '#4caf50',
        warning: '#ff9800',
        info: '#9c27b0',
        light: '#f8f9fa',
        dark: '#222',
        link: '#1a78c2',
      },
      body: {
        color: '#444',
        backgroundColor: '#fff',
        anchor: '#2196f3',
        anchorHover: '#1a78c2',
      },
      defaultFonts: ` -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Helvetica Neue", Arial, sans-serif`,
      headingColor: '#444',
    },
    {
      themeName: 'minty',
      colors: {
        primary: '#78c2ad',
        danger: '#ff7851',
        success: '#56cc9d',
        warning: '#ffce67',
        info: '#6cc3d5',
        light: '#f8f9fa',
        dark: '#343a40',
        link: ' #78c2ad',
      },
      hoverColors: {
        primary: '#78c2ad',
        danger: '#ff7851',
        success: '#56cc9d',
        warning: '#ffce67',
        info: '#6cc3d5',
        light: '#f8f9fa',
        dark: '#343a40',
        link: '#609b8a',
      },
      body: {
        color: '#888',
        backgroundColor: '#fff',
        anchor: '#78c2ad',
        anchorHover: '#609b8a',
      },
      defaultFonts: `system-ui, -apple-system, "Segoe UI", Roboto,
    "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
      headingColor: '#5a5a5a',
    },
    {
      themeName: 'morph',
      colors: {
        primary: '#378dfc',
        danger: '#e52527',
        success: '#43cc29',
        warning: '#ffc107',
        info: '#5b62f4',
        light: '#f0f5fa',
        dark: '#212529',
        link: ' #485785',
      },
      hoverColors: {
        primary: '#378dfc',
        danger: '#e52527',
        success: '#43cc29',
        warning: '#ffc107',
        info: '#5b62f4',
        light: '#f0f5fa',
        dark: '#212529',
        link: '#3a466a',
      },
      body: {
        color: '#7b8ab8',
        backgroundColor: '#d9e3f1',
        anchor: '#485785',
        anchorHover: '#3a466a',
      },
      defaultFonts: `Nunito, -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol"`,
      headingColor: '#485785',
    },
    {
      themeName: 'pulse',
      colors: {
        primary: '#593196',
        danger: '#fc3939',
        success: '#13b955',
        warning: '#efa31d',
        info: '#009cdc',
        light: '#f9f8fc',
        dark: '#17141f',
        link: ' #593196',
      },
      hoverColors: {
        primary: '#593196',
        danger: '#fc3939',
        success: '#13b955',
        warning: '#efa31d',
        info: '#009cdc',
        light: '#f9f8fc',
        dark: '#17141f',
        link: '#593196',
      },
      body: {
        color: '#444',
        backgroundColor: '#fff',
        anchor: '#593196',
        anchorHover: '#593196',
      },
      defaultFonts: `system-ui, -apple-system, "Segoe UI", Roboto,
    "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
      headingColor: '#444',
    },
    {
      themeName: 'quartz',
      colors: {
        primary: '#e83283',
        danger: '#fd7e14',
        success: '#41d7a7',
        warning: '#ffc107',
        info: '#39cbfb',
        light: '#e9e9e8',
        dark: '#212529',
        link: ' #fff',
      },
      hoverColors: {
        primary: '#e83283',
        danger: '#fd7e14',
        success: '#41d7a7',
        warning: '#ffc107',
        info: '#39cbfb',
        light: '#e9e9e8',
        dark: '#212529',
        link: '#cccccc',
      },
      body: {
        color: '#fff',
        backgroundColor: '#686dc3',
        anchor: '#fff',
        anchorHover: '#cccccc',
      },
      defaultFonts: `system-ui, -apple-system, "Segoe UI", Roboto,
    "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
      headingColor: '#fff',
    },
    {
      themeName: 'sandstone',
      colors: {
        primary: '#325d88',
        danger: '#d9534f',
        success: '#93c54b',
        warning: '#f47c3c',
        info: '#29abe0',
        light: '#f8f5f0',
        dark: '#3e3f3a',
        link: ' #93c54b',
      },
      hoverColors: {
        primary: '#325d88',
        danger: '#d9534f',
        success: '#93c54b',
        warning: '#f47c3c',
        info: '#29abe0',
        light: '#f8f5f0',
        dark: '#3e3f3a',
        link: '#769e3c',
      },
      body: {
        color: '#3e3f3a',
        backgroundColor: '#fff',
        anchor: '#93c54b',
        anchorHover: '#769e3c',
      },
      defaultFonts: `Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol"`,
      headingColor: '#3e3f3a',
    },
    {
      themeName: 'simplex',
      colors: {
        primary: '#d9230f',
        danger: '#9b479f',
        success: '#469408',
        warning: '#d9831f',
        info: '#469408',
        light: '#fff',
        dark: '#373a3c',
        link: ' #d9230f',
      },
      hoverColors: {
        primary: '#d9230f',
        danger: '#9b479f',
        success: '#469408',
        warning: '#d9831f',
        info: '#469408',
        light: '#fff',
        dark: '#373a3c',
        link: '#ae1c0c',
      },
      body: {
        color: '#212529',
        backgroundColor: '#fcfcfc',
        anchor: '#d9230f',
        anchorHover: '#ae1c0c',
      },
      defaultFonts: `"Open Sans", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol"`,
      headingColor: '#212529',
    },
    {
      themeName: 'sketchy',
      colors: {
        primary: '#333',
        danger: '#dc3545',
        success: '#28a745',
        warning: '#ffc107',
        info: '#28a745',
        light: '#fff',
        dark: '#555',
        link: ' #333',
      },
      hoverColors: {
        primary: '#333',
        danger: '#dc3545',
        success: '#28a745',
        warning: '#ffc107',
        info: '#28a745',
        light: '#fff',
        dark: '#555',
        link: '#292929',
      },
      body: {
        color: '#212529',
        backgroundColor: '#fff',
        anchor: '#333',
        anchorHover: '#292929',
      },
      defaultFonts: ` Neucha, -apple-system, system-ui, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif`,
      headingColor: '#212529',
    },
    {
      themeName: 'slate',
      colors: {
        primary: '#3a3f44',
        danger: '#ee5f5b',
        success: '#62c462',
        warning: '#f89406',
        info: '#5bc0de',
        light: '#e9ecef',
        dark: '#272b30',
        link: ' #fff',
      },
      hoverColors: {
        primary: '#3a3f44',
        danger: '#ee5f5b',
        success: '#62c462',
        warning: '#f89406',
        info: '#5bc0de',
        light: '#e9ecef',
        dark: '#272b30',
        link: '#cccccc',
      },
      body: {
        color: '#aaa',
        backgroundColor: '#272b30',
        anchor: '#fff',
        anchorHover: '#cccccc',
      },
      defaultFonts: `system-ui, -apple-system, "Segoe UI", Roboto,
    "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
      headingColor: '#aaa',
    },
    {
      themeName: 'solar',
      colors: {
        primary: '#b58900',
        danger: '#d33682',
        success: '#2aa198',
        warning: '#cb4b16',
        info: '#268bd2',
        light: '#fdf6e3',
        dark: '#073642',
        link: ' #002b36',
      },
      hoverColors: {
        primary: '#b58900',
        danger: '#d33682',
        success: '#2aa198',
        warning: '#cb4b16',
        info: '#268bd2',
        light: '#fdf6e3',
        dark: '#073642',
        link: '#2aa198',
      },
      body: {
        color: '#839496',
        backgroundColor: '#002b36',
        anchor: '#002b36',
        anchorHover: '#2aa198',
      },
      defaultFonts: `"Source Sans Pro", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol"`,
      headingColor: '#839496',
    },
    {
      themeName: 'spacelab',
      colors: {
        primary: '#446e9b',
        danger: '#cd0200',
        success: '#3cb521',
        warning: '#d47500',
        info: '#3399f3',
        light: '#eee',
        dark: '#333',
        link: ' #3399f3',
      },
      hoverColors: {
        primary: '#446e9b',
        danger: '#cd0200',
        success: '#3cb521',
        warning: '#d47500',
        info: '#3399f3',
        light: '#eee',
        dark: '#333',
        link: '#297ac2',
      },
      body: {
        color: '#777',
        backgroundColor: '#002b36',
        anchor: '#3399f3',
        anchorHover: '#297ac2',
      },
      defaultFonts: `"Open Sans", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol"`,
      headingColor: '#2d2d2d',
    },
    {
      themeName: 'superhero',
      colors: {
        primary: '#df6919',
        danger: '#d9534f',
        success: '#5cb85c',
        warning: '#ffc107',
        info: '#5bc0de',
        light: '#abb6c2',
        dark: '#20374c',
        link: ' #df6919',
      },
      hoverColors: {
        primary: '#df6919',
        danger: '#d9534f',
        success: '#5cb85c',
        warning: '#ffc107',
        info: '#5bc0de',
        light: '#abb6c2',
        dark: '#20374c',
        link: '#b25414',
      },
      body: {
        color: '#ebebeb',
        backgroundColor: '#0f2537',
        anchor: '#df6919',
        anchorHover: '#b25414',
      },
      defaultFonts: `Lato, -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol"`,
      headingColor: '#ebebeb',
    },
    {
      themeName: 'united',
      colors: {
        primary: '#e95420',
        danger: '#df382c',
        success: '#38b44a',
        warning: '#efb73e',
        info: '#17a2b8',
        light: '#df382c',
        dark: '#772953',
        link: ' #e95420',
      },
      hoverColors: {
        primary: '#e95420',
        danger: '#df382c',
        success: '#38b44a',
        warning: '#efb73e',
        info: '#17a2b8',
        light: '#df382c',
        dark: '#772953',
        link: '#ba431a',
      },
      body: {
        color: '#333',
        backgroundColor: '#002b36',
        anchor: '#e95420',
        anchorHover: '#ba431a',
      },
      defaultFonts: ` Ubuntu, -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol"`,
      headingColor: '#333',
    },
    {
      themeName: 'vapor',
      colors: {
        primary: '#6f42c1',
        danger: '#e44c55',
        success: '#3cf281',
        warning: '#ffc107',
        info: '#1ba2f6',
        light: '#44d9e8',
        dark: '#170229',
        link: ' #32fbe2',
      },
      hoverColors: {
        primary: '#6f42c1',
        danger: '#e44c55',
        success: '#3cf281',
        warning: '#ffc107',
        info: '#1ba2f6',
        light: '#44d9e8',
        dark: '#170229',
        link: '#28c9b5',
      },
      body: {
        color: '#32fbe2',
        backgroundColor: '#1a0933',
        anchor: '#32fbe2',
        anchorHover: '#28c9b5',
      },
      defaultFonts: `Lato, -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol"`,
      headingColor: '#32fbe2',
    },
    {
      themeName: 'yeti',
      colors: {
        primary: '#008cba',
        danger: '#e99002',
        success: '#43ac6a',
        warning: '#e99002',
        info: '#5bc0de',
        light: '#eee',
        dark: '#333',
        link: ' #008cba',
      },
      hoverColors: {
        primary: '#008cba',
        danger: '#e99002',
        success: '#43ac6a',
        warning: '#e99002',
        info: '#5bc0de',
        light: '#eee',
        dark: '#333',
        link: '#007095',
      },
      body: {
        color: '#222',
        backgroundColor: '#1a0933',
        anchor: '#008cba',
        anchorHover: '#007095',
      },
      defaultFonts: `"Open Sans", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol"`,
      headingColor: '#222',
    },
    {
      themeName: 'zephyr',
      colors: {
        primary: '#3459e6',
        danger: '#da292e',
        success: '#2fb380',
        warning: '#f4bd61',
        info: '#287bb5',
        light: '#f8f9fa',
        dark: '#212529',
        link: ' #3459e6',
      },
      hoverColors: {
        primary: '#3459e6',
        danger: '#da292e',
        success: '#2fb380',
        warning: '#f4bd61',
        info: '#287bb5',
        light: '#f8f9fa',
        dark: '#212529',
        link: '#2a47b8',
      },
      body: {
        color: '#495057',
        backgroundColor: '#fff',
        anchor: '#3459e6',
        anchorHover: '#2a47b8',
      },
      defaultFonts: `Inter, -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol"`,
      headingColor: '#495057',
    },
  ];
  const customThemeDataObj = themeData.find((el) => el.themeName === themeName);
  return { customThemeDataObj };
};

export const defaultFonts = [
  {
    name: 'Default',
    value:
      '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
  },
  {
    name: 'Arial',
    style: 'font-family: Arial, Helvetica, sans-serif; font-size:0.8rem',
    value: 'Arial, Helvetica, sans-serif',
  },
  {
    name: 'Arial Black',
    style: 'font-family: Arial Black, Gadget, sans-serif; font-size:0.8rem',
    value: 'Arial Black, Gadget, sans-serif',
  },
  {
    name: 'Helvetica',
    style: 'font-family: Helvetica, sans-serif; font-size:0.8rem',
    value: 'Helvetica, sans-serif',
  },
  {
    name: 'Impact',
    style: 'font-family: Impact, Charcoal, sans-serif; font-size:0.8rem',
    value: 'Impact, Charcoal, sans-serif',
  },
  {
    name: 'Lucida Sans Unicode',
    style: 'font-family: Lucida Sans Unicode, Lucida Grande, sans-serif; font-size:0.8rem',
    value: 'Lucida Sans Unicode, Lucida Grande, sans-serif',
  },
  {
    name: 'Tahoma',
    style: 'font-family: Tahoma, Geneva, sans-serif; font-size:0.8rem',
    value: 'Tahoma, Geneva, sans-serif',
  },
  {
    name: 'Times New Roman',
    style: 'font-family: Times New Roman, Times, serif; font-size:0.8rem',
    value: 'Times New Roman, Times, serif',
  },
  {
    name: 'Trebuchet MS',
    style: 'font-family: Trebuchet MS, Helvetica, sans-serif; font-size:0.8rem',
    value: 'Trebuchet MS, Helvetica, sans-serif',
  },
  {
    name: 'Verdana',
    style: 'font-family: Verdana, Geneva, sans-serif; font-size:0.8rem',
    value: 'Verdana, Geneva, sans-serif',
  },
];

export const drapcodeLog = (
  type = 'log',
  message = 'No message provided',
  data = 'No data available',
) => {
  console.log('inside drapcodelog', type);
  const isEnabled = localStorage.getItem(localStorageKey.DEBUG_MODE)
    ? localStorage.getItem(localStorageKey.DEBUG_MODE) === 'true'
    : false;

  if (isEnabled) {
    switch (type) {
      case 'log':
        console.log(message, data);
        break;
      case 'warn':
        console.warn(message, data);
        break;
      case 'error':
        console.error(message, data);
        break;
      default:
        break;
    }
  }
};

export const loaderScreenValidation = Yup.object({
  opacity: Yup.number()
    .typeError('Opacity must be a number')
    .min(0, 'Opacity cannot be less than 0')
    .max(1, 'Opacity cannot be greater than 1')
    .nullable(),
});

export const typeDescription = `<ul style="padding-left:1rem"><li><strong>Persistent collection</strong> when <em>ON</em> will store item data in <em>DrapCode (default) database</em>.</li><li><strong>Persistent collection</strong> when <em>OFF</em> will not store any item data in <em>DrapCode (default) database</em>.</li></ul>`;
export const createEventsDescription = `<ul style="padding-left:1rem">
      <li>When enabled, <strong>Save</strong>, <strong>Update</strong>, and <strong>Delete</strong> events will be automatically created with the collection.</li>
    </ul>`;

export const headingElements = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
export const getDefaultFontSizes = {
  h1: '32px',
  h2: '28px',
  h3: '24px',
  h4: '20px',
  h5: '18px',
  h6: '16px',
};
export const spaceSection = ['Margin', 'Padding', 'Border', 'BorderRadius'];
export const areaSection = ['Top', 'Bottom', 'Left', 'Right'];

export const collectionTypeBadge = (value, type, name = '') => {
  let infoText = '';
  let label = '';
  let badgeClass = '';

  if (type === 'persist') {
    infoText = value
      ? 'Persistent collection will store item data in DrapCode (default) database.'
      : 'Non-Persistent collection will not store any item data in DrapCode (default) database.';
    label = value ? 'Persistent' : 'Non-Persistent';
    badgeClass = value ? 'badge-info' : 'badge-primary';
  } else if (type === 'inuse') {
    infoText = value ? `This ${name} is currently in use.` : `This ${name} is not in use.`;
    label = value ? 'Yes' : 'No';
    badgeClass = value ? 'badge-primary' : 'badge-theme-danger';
  }

  return (
    <span
      className={`badge ${badgeClass}`}
      style={{ fontWeight: 'bold', cursor: 'default' }}
      title={infoText}
    >
      {label}
    </span>
  );
};

export const descriptionTooltip = (name) => {
  return `<ul style="padding-left:1rem">
  <li><strong>Description</strong> Explains the purpose or usage of the ${name}.</li>
</ul>`;
};

export const inUseTooltip = (name) => {
  return `<ul style="padding-left:1rem">
  <li><strong>Yes</strong> means the ${name} is currently being used by some components, pages, or logic.</li>
  <li><strong>No</strong> means it is available but not actively used anywhere.</li>
</ul>`;
};
export const inUseDescription = `If checked, this item will be marked as active and used across the application. If unchecked, it will be considered inactive and not used anywhere.`;
